<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/salesTable',title:'销售样表'},{title:'销量样表编辑页面'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form :model="f" label-position="right" ref="f" :inline="true" :rules="rules"
                              class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>销售样表信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Bianjiyb">
                                            <el-form-item label="产品编码" class="h-elformWrap-2">
                                                <el-input v-model="f.prodcode" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品型号" class="h-elformWrap-2">
                                                <el-input v-model="f.promodel" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品大类" class="h-elformWrap-2">
                                                <el-input placeholder="输入产品编码自动带出" v-model="f.prodseries" readonly></el-input>

                                                <!--<el-select v-model="f.prodseries" :v="f.prodseries" readonly placeholder="请选择">
                                                    <el-option v-for="(item,index) in LevelName"
                                                               :key="index+1"
                                                               :label="item.levelname"
                                                               :value="item.id">
                                                    </el-option>
                                                </el-select>-->
                                            </el-form-item>

                                            <el-form-item label="型号经理" class="h-elformWrap-2">
                                                <el-input :v="f.userCode" placeholder="请输入" v-model="f.userCode"></el-input>
                                            </el-form-item>
                                       <!--     <el-form-item label="状态" class="h-elformWrap-2">
                                                <brselect category="prodstatus" :v="f.prodstatus" v-model="f.prodstatus"/>
                                            </el-form-item>-->
                                            <el-form-item label="型号属性" class="h-elformWrap-2">
                                                <el-input v-model="f.protype" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="二类是否覆盖6858" class="h-elformWrap-2">
                                                <brselect category="permit" :v="f.have6858" v-model="f.have6858" disabled/>
                                            </el-form-item>
                                            <el-form-item label="二类是否覆盖6840" class="h-elformWrap-2">
                                                <brselect category="permit" :v="f.have6840" v-model="f.have6840" disabled/>
                                            </el-form-item>
                                            <el-form-item label="三类是否覆盖6854" class="h-elformWrap-2">
                                                <brselect category="permit" :v="f.have6854" v-model="f.have6854" disabled/>
                                            </el-form-item>
                                            <el-form-item label="三类是否覆盖6840" class="h-elformWrap-2" prop="three6840">
                                                <brselect category="permit" :v="f.three6840" v-model="f.three6840" disabled/>
                                            </el-form-item>
                                            <el-form-item label="公司名称" class="h-elformWrap-2">
                                                <brselect category="xsyb_gongsi" :v="f.companycode"
                                                          v-model="f.companycode" disabled/>
                                            </el-form-item>
                                            <el-form-item label="产地" class="h-elformWrap-2">
                                                <el-select v-model="f.factory" placeholder="请选择" disabled>
                                                    <el-option value="9393">9393</el-option>
                                                    <el-option value="9370">9370</el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="类别" class="h-elformWrap-2">
                                                <el-select v-model="f.sort" placeholder="请选择" :clearable="true" disabled>
                                                    <el-option value="三高">三高</el-option>
                                                    <el-option value="三生">三生</el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="有效期" class="h-elformWrap-2">
                                                <el-date-picker placeholder="请输入"
																                    v-model="f.validperiod"
                                                    value-format="yyyy-MM-dd"
																	                  :clearable="false" disabled></el-date-picker>
                                            </el-form-item>
                                            <el-form-item label="是否计入销额" class="h-elformWrap-2">
                                                <brselect  category="xiaoe_jishu" :v="f.xiaoe" v-model="f.xiaoe" disabled></brselect>
                                            </el-form-item>
                                            <el-form-item label="是否计入基数" class="h-elformWrap-2">
                                                <brselect category="xiaoe_jishu" :v="f.jishu" v-model="f.jishu" disabled></brselect>
                                            </el-form-item>
                                            <el-form-item label="链群" class="h-elformWrap-2">
                                                <brselectlazy category="xsyb_lianqun" v-model="f.lianqun"
                                                              :v="f.lianqun" disabled></brselectlazy>
                                            </el-form-item>
                                            <el-form-item label="子链群" class="h-elformWrap-2" prop="lianqunchild">
                                                <brselectlazy category="xsyb_lianqunchild" v-model="f.lianqunchild"
                                                              :v="f.lianqunchild" :clearable="true" disabled></brselectlazy>
                                            </el-form-item>

                                            <el-form-item label="是否服务产品" class="h-elformWrap-2" prop="isFw">
                                                <el-select v-model="f.isFw" :v="f.isFw" placeholder="请选择" disabled>
                                                    <el-option v-for="(item) in fwList"
                                                               :key="item.code"
                                                               :label="item.name"
                                                               :value="item.code">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <!-- <el-form-item label="子链群" class="h-elformWrap-2">
                                                <el-input v-model="f.lianqunchild" readonly></el-input>
                                            </el-form-item> -->

                                            <el-form-item label="渠道专供" class="h-elformWrap-3" disabled="">
                                                <brselectlazy :multiple="true" category="sales_region" :v="f.channel" v-model="f.channel" />
                                            </el-form-item>

                                            <el-form-item label="区域" class="h-elformWrap-3"   prop="areacodelist">

                                                <el-checkbox  @change="selectAll" disabled>全选</el-checkbox>
                                                <div style="margin: 15px 0;"></div>
                                                <el-checkbox-group v-model="f.areacodelist" >
                                                    <el-checkbox v-for="item in options" :label="item.value" :key="item.value" disabled >{{item.label}}</el-checkbox>
                                                </el-checkbox-group>

                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
          <div class="h-table h-mrt30 h-rowBox" style="margin-top:0.4rem">
            <div class="h-pieceTitle2 hang">
              <h1 class="h1" style="margin-left:20px">审批</h1>
              <el-form :model="expandShenpi" label-position="right" :inline="true"
                       class="demo-ruleForm h-formbLine ">
                <el-form-item label="审批意见" class="h-elformWrap-2 w-elformWrap-3" :required="true" style="margin-top:0.2rem;margin-left: 0.2rem;">
                  <el-input v-model="expandShenpi.shenheyijian" placeholder="请输入"
                            :disabled="taskstatus==1" ></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
            <div class="apprButton" style="margin-top: 0.4rem; text-align: center;">
              <el-row>
                <el-button class=" h-btn h-bBtn h-bgwhite" @click="returnTable">返回</el-button>
                <el-button class="el-button h-btn h-bBtn h-bgred el-button--default"
                           @click="shenpi(2)">驳回
                </el-button>
                <el-button class="el-button h-btn h-bBtn h-bggreen el-button--default"
                           @click="shenpi(1)">通过
                </el-button>
                <el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
              </el-row>
              <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
            </div>
        </div>
    </div>
</template>

<script>
	import ss from '../../api/SystemService'
 	export default {
		data() {
			return {
        f:{
            areacodelist: [],
        },
        LevelName: [],
        rules: {
            prodseries: [{required: true, message: '请选择产品大类', trigger: 'change'}],
            lianqun: [{required: true, message: '请选择链群', trigger: 'change'}],
            areacodelist: [{required: true, message: '请选择区域', trigger: 'change'}],

        },
        options: [],
        fwList:[
            {code:1,name:"是"},
            {code:0,name:"否"}
        ],
        expandShenpi:{
          shenheyijian:"",
        },
        taskstatus:'',
        showhistory:false,
        instid:'',
        taskid:'',
        //物料id
        ywid:'',
			}
		},
		created() {
			this.query();
            this.showLevelName();
            //获取当前路由参数中的instid
            this.instid = this.$router.history.current.query.instid;
            //taskid
            this.taskid = this.$router.history.current.query.taskid;

            //instid
            this.ywid = this.$router.history.current.query.ywid;
            //初始化内销区域
            var area = this.$store.getters.dictlist("YlSalesArea_chanpin");
            const options = []
            for (var i = 0; i < area.length; i++) {
                var opt = {
                    value: area[i].code,
                    label: area[i].name
                };
                //不是9开头表示内销区域
                if(opt.value.substring(0, 1) != "9"){
                    options.push(opt)
                }

            }
            this.options = options

		},
		methods: {

      //产品大类
      showLevelName() {
          ss.UserDemand.showLevelName().then(rd => {
              this.LevelName = rd;
          })
      },
			query() {
				this.f.id = this.$route.query.ywid;
				ss.salesList.selectById(this.f.id).then(rd => {
				    this.f = rd;
					this.$set(this.f,'areacodelist', []);
                    this.f.areacodelist = this.f.areacode? this.f.areacode.split(","): [];
					this.f.companyname = this.$getDictName("xsyb_gongsi",this.f.companycode);
                    this.f.lianqunname = this.$getDictName("xsyb_lianqun",this.f.lianqun);
				})
			},
      selectAll(v) {
          if(v){
              this.f.areacodelist = []
              for (var i = 0; i < this.options.length; i++) {
                  this.f.areacodelist.push(this.options[i].value);
              }
           }else{
              this.f.areacodelist = []
          }
      },
      shenpi(q){
        var shenPiEntity = {
          id: this.ywid,//业务主键
          taskid: this.taskid,//页面拿到的taskid
          msg: this.expandShenpi.shenheyijian,//  页面填写的审核意见
          instid:this.instid,//选择要进入的审批版本id
        }
        // 通过还是驳回的flag  1驳回  2通过
        if(q==2){
          shenPiEntity.result=2;
          shenPiEntity.optflag = '驳回';
          if (!this.expandShenpi.shenheyijian) {
            this.$msg.msge("驳回必须输入审批意见！");
            return;
          }

        }else if(q==1){

          shenPiEntity.result=1;
          shenPiEntity.optflag = '通过';
        }
        ss.salesList.expandCompanyShp(shenPiEntity).then(rd => {
          if(rd.f==true){

            this.$msg.alerts("提交成功！",()=>{
              //刷新右上角的代办个数
              this.$store.dispatch("searchTasktotal")
              this.$router.go(-1);
            })
          }
        })
      },
      viewpress(){
        this.showhistory = true;
      },
      returnTable() {
        // this.$router.go(-1);
        this.$router.push({path: '/personal/dealCenter'})
      }
		}
	}
</script>

<style>
	.Bianjiyb .el-form-item__label {
		width: 42%;
		text-align: right;
	}

	.Bianjiyb .el-form-item__content {
		width: 58%;
	}

	.Bianjiyb .h-elformWrap-2 {
		width: 33.333% !important;
		padding-right: 0.5rem
	}
	.Bianjiyb .h-elformWrap-3 {
		width: 100%;
		padding-right: 0.5rem
	}
	.Bianjiyb .h-elformWrap-3 .el-form-item__label {
		width: 13%;
	}
	.Bianjiyb .h-elformWrap-3 .el-form-item__content {
		width: 87%;
	}
</style>
